// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.formContainer[data-v-92aa9cf6]{\n  position: relative;\n  width: 100%;\n  margin: 0 auto;\n}\n.send-email[data-v-92aa9cf6]{\n  margin-left: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
